module.exports = __webpack_public_path__ + "static/media/howtounit.efd1e1a7.png";